import imagesLoaded from "imagesloaded"
export default () => ({

    link : null,
    thisAlignmentElement:null,
    loaded:false,
    paddingToText: 40,

    src: null,
    images: null,
    imageElementSize:null,

    imagesPos: 0,
    timer: null,
    timerDuration: 300,
    async init() {

        this.link = this.$el.querySelector('a[href="#video"]');
        this.thisAlignmentElement = this.$el;
        
        this.link.addEventListener('mouseenter',this.onMouseEnter.bind(this),false)
        this.link.addEventListener('mouseleave',this.onMouseLeave.bind(this),false)
        this.imageElementSize = 300;

        this.$refs.image.style.width=`${this.imageElementSize}px`;
        this.$refs.image.style.height=`${this.imageElementSize}px`;
        
        imagesLoaded( this.$refs.container, (e)=>{
            this.loaded = true;
        } )


        // TODO: How do we handle lazy loading and do we load all images in advance?
        try {
            const images = this.$refs.container.querySelectorAll('img');
            this.images = images;
      
            this.src = this.images[this.imagesPos].src;
            this.imagesPos = this.imagesPos + 1;

            // wait for all images to be loaded..
        } catch (error) {
            //console.log(error)
        }
    },
    onMouseEnter() {
   
        if(!this.loaded) return;
        this.start()
        this.timer = setInterval(() => this.start(), this.timerDuration);

    },
    onMouseLeave() {
        this.$refs.image.classList.add('opacity-0')
        if (this.timer) clearInterval(this.timer);
    },
    start() {
        try {
            if(this.images.length<=1) return;
            this.$refs.image.style.left=`${this.thisAlignmentElement.offsetLeft - (this.imageElementSize + this.paddingToText)}px`
            this.$refs.image.style.top=`${this.link.offsetTop - (this.imageElementSize/2)}px`  
            this.$refs.image.classList.remove('opacity-0')
            this.src = this.images[this.imagesPos].src;
            this.imagesPos = this.imagesPos + 1;
            if (this.imagesPos >= this.images.length) this.imagesPos = 0
        } catch (error) {
            console.warn(error)
        }

    }
})


// export default () => ({

//     link:null,
//     thisAlignmentElement:null,
//     paddingToText: 40,
//     videoElementWidth:null,
//     videoElementHeight:null,
    
//     init(){
//         this.link = this.$el.querySelector('a[href="#video"]');
//         this.thisAlignmentElement = this.$el;
//         this.link.addEventListener('mouseenter',this.playVideo.bind(this),false)
//         this.link.addEventListener('mouseleave',this.pauseVideo.bind(this),false)
//         this.videoElementWidth = this.$refs.video.clientWidth
//         this.videoElementHeight = this.$refs.video.clientHeight

//         console.log('%c%s', 'color: #cc0036', 'Height',this.videoElementHeight);
//         console.log('%c%s', 'color: #cc0036', 'Width',this.videoElementWidth);
        
//     },

//     pauseVideo(){
//         this.$refs.video.pause()
//         this.$refs.video.classList.add('opacity-0')
        
//     },
//     playVideo(){
        
//         // Place the video element next to the text.
//         this.$refs.video.style.left=`${this.thisAlignmentElement.offsetLeft - (this.videoElementWidth + this.paddingToText)}px` 

//         // Center the video element in height
//         this.$refs.video.style.top=`${this.link.offsetTop - (this.videoElementHeight/2)}px` 
//         // this.$refs.video.style.left=`${this.thisAlignmentElement.offsetLeft + 150}px` 
//         // this.$refs.video.style.top=`${this.thisAlignmentElement.offsetTop - 150}px` 
//         this.$refs.video.classList.remove('opacity-0')
//         this.$refs.video.play()
//     }

// });